import { Icon } from "@/components/icon/Icon";
import "./users-table.css";
import type { Column } from "@/types/array.types";
import { useState } from "react";
import { InputText } from "@/components/input-text";
import { Dropdown } from "@/components/dropdown";
import type { ProfileType, ProfileTypeWithRole, Role } from "../../pages/admin-users/viewModel";



interface UsersTableProps {
    columns: Column<ProfileTypeWithRole>[];
    users: ProfileTypeWithRole[];
    roles: Role[];
    onDelete: (id: string) => void;
    onUpdate: (id:string, values: Partial<ProfileType>) => void;
  }

export function UsersTable({columns, roles, users, onDelete, onUpdate}: UsersTableProps) {

    const [values, setValues] = useState({
        full_name: "",
        role_id: ""
      });

    const [editing, setEditing] = useState<string | null>(null);
    const startEdit = (user: ProfileType) => {
        setEditing(user.id);

        setValues({
            full_name: user.full_name,
            role_id: user.role_id
        });
    };

    const onSubmit = (id: string, values: Partial<ProfileType>) => {
      setEditing(null);
      onUpdate(id, values)
    }
    
    return <table>
    <thead className={"table-header"}>
        <tr>
        {columns.map((column, index) => {
            return  column.key != "id" && <th key={`header_${index}`}> {column.label}</th>
        })}
        <th>{editing ? "Enregistrer ?" : "Actions"}</th>
        </tr>     
    </thead>
    <tbody className={"table-body"}>
        {users?.map((user, rowIndex) => (
          <tr className="admin-table-row" key={rowIndex}>
            {columns.map((column, colIndex) => (
              column.key != "id" &&
              <td key={colIndex}>
              {editing === user.id && column.key === "full_name" ? (
                <div className="admin-users-update-name">
                <InputText
                    className="admin-users-input-text"
                    name="name"
                    value={values.full_name}
                    onChange={(e) =>
                        setValues({
                        ...values,
                        full_name: e.target.value,
                        })}
                >
                  </InputText>
                  </div>) : 
                editing === user.id && column.key === "roles" ? (
                    <Dropdown
                        className="admin-users-input-select"
                        label={roles.find((role) => role.id === values.role_id)?.name ?? ""}
                        options={roles.map((role) => role.name)}
                        value={roles.find((t) => t.id === values.role_id).id}
                        onChange={(value) => {
                        const role = roles.find((role) => role.name === value);
                            
                        if (!role) return;
                    
                        setValues({
                            ...values,
                            role_id: role.id,
                        });
                        }}
                  />
            ) : (
                column.render
                ? column.render(user)
                : String(user[column.key] ?? "")
            )}
              </td>
            ))}
             <td className="column-actions">
              {editing === user.id ? <> 
                <div onClick={() => onSubmit(user.id, values)}><Icon className={"admin-users-icon admin-users-icon-validate"} name={"check"}/></div>
                <div onClick={() => setEditing(null)}><Icon className={"admin-users-icon admin-users-icon-cancel"} name={"close"}/></div>
              </> 
              : <> 
                <div onClick={() => startEdit(user)}><Icon className={"icon-edit"} name={"edit"}/></div>
                <div onClick={() => onDelete(user.id)}><Icon className={"icon-delete"} name={"delete"}/></div>
              </>}
             </td> 
          </tr>
        ))}
      </tbody>
    </table>
    
};